import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { Button } from "./Button";
import { LOGO_URL, MOTTO_LINES } from "../data/content";
export function Hero() {
  return <section id="inicio" className="bg-ink pt-20 text-paper" data-id="element-130" data-mp="9luzmm7107tq">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-6 py-16 text-center lg:py-24" data-id="element-131" data-mp="4lyvmmybwge6">
        <motion.img src={LOGO_URL} alt="Escudo de Fortis Sports Management: un águila dorada con alas formadas por banderas del mundo" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        WebkitMaskImage: "radial-gradient(circle at center, #000 74%, transparent 100%)",
        maskImage: "radial-gradient(circle at center, #000 74%, transparent 100%)"
      }} className="aspect-square w-80 object-contain mix-blend-lighten sm:w-[26rem] lg:w-[30rem]" data-id="element-132" data-mp="1297a3xzwwp6o" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 flex flex-col items-center" data-id="element-133" data-mp="3j9tzsvxzjik8">
          <h1 className="max-w-3xl text-4xl font-semibold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-134" data-mp="3e9fpt8ctpyjk">
            Representación integral para <span className="text-gold" data-id="element-135" data-mp="30gztsricb0s5">futbolistas</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-paper/75" data-id="element-136" data-mp="3599iy5bmrwtd">
            Acompañamos al jugador en contratos, oportunidades, bienestar e imagen profesional, con decisiones
            estratégicas en cada etapa de la carrera.
          </p>
          <div className="mt-10" data-id="element-137" data-mp="2vgtzt4oll26w">
            <Button href="#contacto" data-id="element-138" data-mp="2hjf8fuesakca">
              Hablar con Fortis
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-139" data-mp="2hl9q8zurdwc5" />
            </Button>
          </div>

          <blockquote className="mt-16 flex flex-col items-center" data-id="element-140" data-mp="2lml98mj4njbd">
            <span className="h-px w-16 bg-gold" aria-hidden="true" data-id="element-141" data-mp="s3mb9x0ezovq" />
            <p className="mt-6 text-base italic leading-relaxed text-paper/85 sm:text-lg" data-id="element-142" data-mp="nb1imyt8vhts">
              {MOTTO_LINES.map(line => <span key={line} className="block" data-id="element-143" data-mp="ichwoyeni61f">
                  {line}
                </span>)}
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}